// extracted by mini-css-extract-plugin
export default {"PriceDifference":"PriceDifference__PriceDifference___A4gnC","differenceSign":"PriceDifference__differenceSign___JX25S"};